export const SETTINGS_STALE_TIME: number = 60 * 1000

export const DEFAULT_NET_PRESETS: number[] = [7, 14, 30, 45, 60]

export const BASE_INPUT_FIELD_STYLES = {
  width: '270px'
} as const
